<span class="roll-part" *ngFor="let roll of rolls">
    <ng-container *ngIf="roll.success==false">
        <span class="roll-value" [ngStyle]="{'color': color}">{{roll.value}}</span>
    </ng-container>
    <ng-container *ngIf="roll.success==true">
        <span class="roll-value" [ngStyle]="{'color': 'limegreen' }" *ngIf="roll.value==1">{{roll.roll}}</span>
        <span class="roll-value" [ngStyle]="{'color': 'orangered' }" *ngIf="roll.value==0">{{roll.roll}}</span>
    </ng-container>
    <span class="roll-die">{{roll.die}}</span>
</span>